import { render, staticRenderFns } from "./MegaboxBanner.vue?vue&type=template&id=133120f2&"
import script from "./MegaboxBanner.vue?vue&type=script&lang=js&"
export * from "./MegaboxBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports